import useIsRtl from "@/hooks/useIsRtl";

interface Props {
  next?: boolean;
}

const SvgPrevNextArrow: React.FC<Props> = ({ next = false }) => {
  const isRTL = useIsRtl();
  const flip = (next && !isRTL) || (!next && isRTL);
  return (
    <svg
      style={
        flip ? { WebkitTransform: "scaleX(-1)", transform: "scaleX(-1)" } : {}
      }
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12243_6529)">
        <path
          d="M11.1562 2.12813C11.0176 2.13226 10.8861 2.19017 10.7895 2.28959L5.4562 7.62292C5.35621 7.72295 5.30005 7.85858 5.30005 8.00001C5.30005 8.14143 5.35621 8.27707 5.4562 8.37709L10.7895 13.7104C10.8387 13.7616 10.8975 13.8025 10.9627 13.8306C11.0278 13.8588 11.0979 13.8737 11.1689 13.8744C11.2398 13.8751 11.3102 13.8617 11.3759 13.8348C11.4416 13.808 11.5013 13.7684 11.5515 13.7182C11.6016 13.668 11.6413 13.6083 11.6681 13.5426C11.6949 13.4769 11.7084 13.4065 11.7076 13.3356C11.7069 13.2646 11.6921 13.1945 11.6639 13.1294C11.6357 13.0643 11.5949 13.0054 11.5437 12.9563L6.58745 8.00001L11.5437 3.04376C11.6208 2.96884 11.6734 2.87239 11.6947 2.76705C11.716 2.66171 11.705 2.55238 11.6631 2.4534C11.6212 2.35442 11.5504 2.27041 11.46 2.21237C11.3695 2.15432 11.2636 2.12496 11.1562 2.12813Z"
          fill="#5B5B5B"
        />
      </g>
      <defs>
        <clipPath id="clip0_12243_6529">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgPrevNextArrow;
